const projectData = () => ({
    targets: [
        {
            isStage: true,
            name: 'Stage',
            variables: {},
            lists: {},
            broadcasts: {},
            blocks: {},
            comments: {},
            currentCostume: 0,
            costumes: [{
                assetId: 'c17163c6954e9422ac2405de4c9d68c8',
                name: '',
                bitmapResolution: 1,
                md5ext: 'c17163c6954e9422ac2405de4c9d68c8.svg',
                dataFormat: 'svg',
                rotationCenterX: 207,
                rotationCenterY: 16
            }],
            sounds: [],
            volume: 100,
            layerOrder: 0
        }
    ],
    monitors: [],
    extensions: [],
    meta: {
        semver: '3.0.0',
        vm: '0.2.0',
        agent: ''
    }
});

export default projectData;
